// Modules
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import DatePicker from "react-datepicker";
import _ from "lodash";
// CSS
import '_Asset/css/User/Page/connect.css';
import 'react-datepicker/dist/react-datepicker.css';
// Component
import { Pagination, PostList } from 'User/Component';
// API
import { NewsListApi } from "_Route/Api";


const News = () => {

  // Use module
  const { t } = useTranslation();
  const params = useParams()
  const navigate = useNavigate();


  // Search Input Value Setting
  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/connect/news${searchTitle === '' || searchTitle === undefined ? '' : '/' + encodeURIComponent(searchTitle)}`);
  }

  const location = useLocation();
  const postGroupRef = useRef(null);
  let heightArr = [];

  
  // 검색 및 페이징 API 호출
  const [searchInfo, setSearchInfo] = useState([]); // Search Result Paging Data
  const [searchRes, setSearchRes] = useState([]); // Search Result Data
  
  const [searchTitle, setSearchTitle] = useState(); // 검색할 타이틀
  const [searchDate, setSearchDate] = useState(); // 수정 날짜
  const [startDate, setStartDate] = useState(); // 생성 날짜 (시작)
  const [lastDate, setLastDate] = useState(new Date()); // 생성 날짜 (끝)
  const [category, setCategory] = useState(); // 검색할 카테고리
  const [curPage, setCurPage] = useState(1); // 현재 페이지
  const [pageSize, setPageSize] = useState(30); // 한 페이지에 보여줄 건 수 (Results)
  const [blockSize, setBlockSize] = useState(10); // 한 페이지에 보여줄 Pagination 블록 건 수

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // setLoading(false)
    axios.get(NewsListApi, {
      params: {
        news_title: params.key === undefined ? '' : params.key,
        news_last_modify_date: searchDate,
        news_start_date: startDate === undefined ? startDate : new Date(startDate),
        news_last_date: new Date(lastDate),
        news_category: category === '' ? undefined : category,
        curPage: curPage,
        pageSize: pageSize,
        blockSize: blockSize,
      }
    })
    .then(res => {    
      setSearchInfo(res.data.pageInfo);
      setSearchRes(res.data.result);
      // listGrid()
    })
    .catch(err => {
      console.error("ERROR", err)
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, curPage, pageSize, searchDate, startDate, lastDate, category])


  // Skeleton Component
  const Skeleton = ({num}) => {
    const result = [];

    for (let i = 0; i < num; i++) {
      result.push(
        <div key={i} className="postItem skeleton" >
          <p className="imgBox"></p>

          <div className="postInner">
            <div className="category">
              <p>category</p>
              <span>tag</span>
            </div>
            
            <div className="postTxtGroup">
              <strong>출금 장애 및 해소 안내드립니다.</strong>
              <p>페이게이트 입니다. 세이퍼트 API 중 조회 조건 없이 하위 멤버를 조회하는 allInfo 기능에 부하가 과하여 검색 조건 없이 조회를 할 경우 업체의 정보만</p>
            </div>

            <div className="registInfo">
              <p>Admin</p>
              <span>July 8, 2022</span>
            </div>
          </div>
        </div>
      )
    }
    return result;
  }


  return (
    <>
      {/* Visual */}
      <div className="visual connect">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">News</h2>
            
            <p className="visualTxt">Seyfert Developers News and Updates.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="newsArea areaBox">

            <div className="flexBox search">
              <fieldset>
                <legend>콘텐츠 검색</legend>

                <div className="fieldGroup row">
                  <div className="field gap">
                    <input type="input" className="input md round_10" onChange={(e) => setSearchTitle(e.target.value)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                    <button type="button" className="btn sm round_10 sfrtBlue" onClick={onSearch}>검색</button>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="flexBox between end">
              <fieldset className="row">
                <div className="fieldGroup">
                  <label className="sm">수정 날짜</label>

                  <div className="field">
                    <select name="" className="select sm type_1 round_10" onChange={(e) => setSearchDate(e.target.value)}>
                      <option value="">모든 기간</option>
                      <option value="day">하루 전</option>
                      <option value="week">일주일 전</option>
                      <option value="month">한달 전</option>
                      <option value="year">일년 전</option>
                    </select>
                  </div>
                </div>

                <div className="fieldGroup">
                  <label className="sm">기간 선택</label>

                  <div className="field gap">
                    <div className="inputIco">
                      <DatePicker
                        className="input sm round_10 i_rt"
                        // showTimeSelect
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        dateFormat="yyyy.MM.dd"
                        maxDate={new Date(lastDate)}
                      />
                      <i className="icofont-calendar"></i>
                    </div>

                    <span>~</span>

                    <div className="inputIco">
                      <DatePicker
                        className="input sm round_10 i_rt"
                        // showTimeSelect
                        selected={lastDate}
                        onChange={date => setLastDate(date)}
                        dateFormat="yyyy.MM.dd"
                        minDate={new Date(startDate)}
                        maxDate={new Date()}
                      />
                      <i className="icofont-calendar"></i>
                    </div>
                  </div>
                </div>

                <div className="fieldGroup">
                  <label className="sm">카테고리</label>

                  <div className="field">
                    <select name="" className="select sm type_1 round_10" onChange={(e) => setCategory(e.target.value)}>
                      <option value="">모두</option>
                      <option value="news">NEWS</option>
                      <option value="notice">NOTICE</option>
                    </select>
                  </div>
                </div>
              </fieldset>
              
              <div className="fieldGroup row gap">
                <label>게시물 수</label>

                <div className="field">
                  <select name="" className="select type_1 round_10 sm" onChange={(e) => setPageSize(e.target.value)} defaultValue="30">
                    <option value="10">10개 씩</option>
                    <option value="20">20개 씩</option>
                    <option value="30">30개 씩</option>
                    <option value="40">40개 씩</option>
                    <option value="50">50개 씩</option>
                    <option value="60">60개 씩</option>
                    <option value="70">70개 씩</option>
                    <option value="80">80개 씩</option>
                    <option value="90">90개 씩</option>
                    <option value="100">100개 씩</option>
                  </select>
                </div>
              </div>
            </div>

            {
              loading ?
                searchRes.length !== 0 ?
                <>
                  <div className="postGroup" ref={postGroupRef}>
                    {searchRes.map((data, i) =>
                      <PostList item={data} index={i} key={i} heightArr={heightArr} type='news' ref={postGroupRef} />
                    )}
                  </div>

                  <div className="flexBox center">
                    <Pagination
                      type="type_2"
                      size="lg"
                      curPage={curPage}
                      setCurPage={setCurPage}
                      pageSize={pageSize}
                      blockSize={blockSize}
                      startBlock={searchInfo.startBlock}
                      endBlock={searchInfo.endBlock}
                      pageCount={searchInfo.pageCount}
                    />
                  </div>
                </>
                :
                <div className="noDataBox">
                  <i className="icofont-warning-alt"></i>
                  <p>No results found for <span>{params.key}</span>.<br /> Please enter another search term.</p>
                </div>
              :
              <div className="postGroup">
                <Skeleton num={9} />
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default News;